"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    appNameMap: ()=>appNameMap,
    mapPinType: ()=>mapPinType,
    products: ()=>products,
    productsType: ()=>productsType,
    viewType: ()=>viewType,
    viewTypeToProductIdMap: ()=>viewTypeToProductIdMap
});
const products = {
    FLY: 'Flight',
    STAY: 'Hotel',
    DRIVE: 'Car',
    PACKAGE: 'Package'
};
const productsType = {
    FLY: 'FLY',
    STAY: 'STAY',
    DRIVE: 'DRIVE',
    PACKAGE: 'PACKAGE'
};
const mapPinType = {
    AIRPORT: 'AIRPORT',
    ATTRACTION: 'ATTRACTION',
    BEACH: 'BEACH',
    CITY: 'CITY',
    HOTEL: 'HOTEL',
    MUSEUM: 'MUSEUM',
    POI: 'POI',
    RESTAURANT: 'RESTAURANT',
    MOUNTAIN: 'MOUNTAIN',
    PARK: 'PARK',
    ACTIVITY: 'ACTIVITY'
};
const viewType = {
    STAYDETAILS: 'STAYDETAILS',
    STAYLISTINGS: 'STAYLISTINGS',
    FLYDETAILS: 'FLYDETAILS',
    FLYLISTINGS: 'FLYLISTINGS',
    DRIVE: 'DRIVE',
    PORTAL: 'PORTAL',
    CHECKOUT: 'CHECKOUT',
    LANDING: 'LANDING',
    ITINERARY: 'ITINERARY'
};
const appNameMap = {
    relax: [
        viewType.STAYLISTINGS
    ],
    'relax-at': [
        viewType.STAYDETAILS
    ],
    'travel-itinerary': [
        viewType.ITINERARY
    ],
    'drive-search-responsive': [
        viewType.DRIVE
    ],
    'fly-search': [
        viewType.FLYDETAILS,
        viewType.FLYLISTINGS
    ],
    'next-landing': [
        viewType.LANDING
    ],
    'cart-checkout': [
        viewType.CHECKOUT
    ]
};
const viewTypeToProductIdMap = {
    [viewType.PORTAL]: -1,
    [viewType.FLYDETAILS]: 1,
    [viewType.FLYLISTINGS]: 1,
    [viewType.STAYDETAILS]: 5,
    [viewType.STAYLISTINGS]: 5,
    [viewType.DRIVE]: 8
};
exports.appNameMap = __webpack_exports__.appNameMap;
exports.mapPinType = __webpack_exports__.mapPinType;
exports.products = __webpack_exports__.products;
exports.productsType = __webpack_exports__.productsType;
exports.viewType = __webpack_exports__.viewType;
exports.viewTypeToProductIdMap = __webpack_exports__.viewTypeToProductIdMap;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "appNameMap",
    "mapPinType",
    "products",
    "productsType",
    "viewType",
    "viewTypeToProductIdMap"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
